import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Mail, Send } from 'lucide-react';
import { settingsAPI } from '../utils/api';

const Footer = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    settingsAPI.get().then(({ data }) => setSettings(data)).catch(() => {});
  }, []);

  return (
    <footer className="nocturne-footer">
      <div className="nocturne-footer-main">
        <div className="nocturne-footer-brand">
          <Link to="/" className="nocturne-brand">
            <span className="nocturne-orbit" aria-hidden="true" />
            <span>LNG<span>AUA</span></span>
          </Link>
          <p>{settings?.site_description || 'Умный перевод текста и голоса прямо в Telegram.'}</p>
        </div>

        <div>
          <h3>Продукт</h3>
          <Link to="/tariffs">Тарифы</Link>
          <Link to="/partner-program">Партнёрская программа</Link>
          <a href="https://t.me/lngaua_bot" target="_blank" rel="noreferrer">Telegram-бот <ArrowUpRight size={13} /></a>
        </div>
        <div>
          <h3>Информация</h3>
          <Link to="/blog">Блог</Link>
          <Link to="/support">Поддержка</Link>
          <Link to="/privacy">Конфиденциальность</Link>
          <Link to="/terms">Условия</Link>
        </div>
        <div>
          <h3>Связаться</h3>
          {settings?.contact_email && <a href={`mailto:${settings.contact_email}`}><Mail size={14} /> {settings.contact_email}</a>}
          {settings?.telegram_channel && <a href={settings.telegram_channel} target="_blank" rel="noreferrer"><Send size={14} /> Telegram-канал</a>}
          {!settings?.contact_email && !settings?.telegram_channel && (
            <a href={settings?.support_chat || 'https://t.me/lngaua_bot'} target="_blank" rel="noreferrer"><Send size={14} /> Написать в Telegram</a>
          )}
        </div>
      </div>

      <div className="nocturne-footer-bottom">
        <span>© {new Date().getFullYear()} LNG AUA</span>
        <span>AI-перевод без языковых границ</span>
      </div>
    </footer>
  );
};

export default Footer;
